import propTypes from 'prop-types';
import { BadgeStyled } from './styles';

const Badge = ({ variant = 'md', ...props }) => {
  return <BadgeStyled variant={variant} {...props} />;
};

Badge.propTypes = {
  variant: propTypes.oneOf(['md', 'lg']),
};

Badge.defaultProps = {
  variant: 'md',
};

export default Badge;
